import { getBrowserSupabaseClient } from "@wtc/supabase";
import { MODAL_IDS } from "@wtc/ui";

import { logger } from "@/lib/logger";
import { buildSendTextModalDataFromContext } from "@/lib/utils/crm/contact-method-context";

import type { ClientRunHooks, ClientRunResolved } from "../types";

/** Open send-text-message with resolved contact phone prefilled. */
export async function openSendTextMessageModal(
  resolved: Pick<ClientRunResolved, "targetIds" | "fields" | "prefetchedTargets">,
  hooks: ClientRunHooks
): Promise<void> {
  hooks.closeModal(MODAL_IDS.actions.resolver);

  const contactId = resolved.targetIds[0];
  let phone = resolved.fields.phone?.trim();
  let item: Record<string, unknown> | undefined;

  if (resolved.prefetchedTargets?.length) {
    const contact = resolved.prefetchedTargets[0];
    item = {
      id: contact.id,
      name: contact.name,
      email: contact.email,
      phone,
    };
  } else if (contactId) {
    const supabase = getBrowserSupabaseClient();
    const { data, error } = await supabase
      .from("contacts")
      .select("id, name, phone, email, company_id")
      .eq("id", contactId)
      .single();

    if (error) {
      logger.error("Failed to fetch contact for send-text modal", error, {
        contactId,
      });
    }

    if (data) {
      item = data as Record<string, unknown>;
      if (!phone && typeof data.phone === "string") {
        phone = data.phone.trim();
      }
    }
  }

  if (!phone) {
    hooks.onToast("No phone number available", "warning");
    return;
  }

  hooks.openModal(
    MODAL_IDS.messages.sendText,
    buildSendTextModalDataFromContext(phone, {
      item: item ?? { id: contactId, phone },
      entityType: "contacts",
    }) as Record<string, unknown>
  );
}
